module.exports = __webpack_public_path__ + "static/media/groceries_icon.a5e54036.svg";